import { apiSlice } from '../../api/apiSlice';

export const publicAssignmentApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllPublicAssignments: builder.mutation({
      query: (options) => ({
        url: `PublicAssignment/Course/${options.courseId}/${options.skip}/${options.take}?archived=${options.archived}`,
        method: 'POST',
        credentials: 'include',
        body: options.qTypes
      })
    }),
    getPublicAssignmentInfo: builder.mutation({
      query: (options) => ({
        url: `PublicAssignment/${options.assignmentId}/AssignmentInfo`,
        method: 'GET',
        credentials: 'include'
      })
    })
  })
});

export const {
  useGetAllPublicAssignmentsMutation,
  useGetPublicAssignmentInfoMutation
} = publicAssignmentApi;